import axios from 'axios';
import { Subscription } from '../../common/model/dto/subscription';
import { Paginated } from '../../common/types';
import { ADMIN_SUBSCRIPTIONS_ROUTE } from '../../api/backend';

export const getSubscriptions = async (
  query: string
): Promise<Paginated<Subscription>> => {
  const { data } = await axios.get(`/${ADMIN_SUBSCRIPTIONS_ROUTE}?${query}`);

  return data;
};
